<div *ngIf="!IsPageLoaded; else populated;">
    <img src="https://dkzxkcjlbnjui.cloudfront.net/portal/loader/loading-page.gif" style="padding: 10% 35%;">
</div>
<ng-template #populated>
    <div class="cManikPopupWidth">
        <div class="main-content">
            <div class="cPopupContainer">
                <div class="cPopupSidebarNarrow">
                    <div class="cPopupMenu1">
                        <ul class="nav">
                            <li data-toggle="collapse" class="collapsed">
                                <a matTooltip="Menu" [matTooltipPosition]="'right'" (click)="ShowWorkspace('Menu')">
                                    <i class="material-icons">menu</i>
                                </a>
                            </li>
                        </ul>
                        <!-- <ul class="nav cPopupLowerUL">
                            <li data-toggle="collapse" class="collapsed">
                                <a matTooltip="Background" [matTooltipPosition]="'right'"
                                    (click)="ShowWorkspace('Background')">
                                    <i class="material-icons">pages</i>
                                </a>
                            </li>
                        </ul> -->
                    </div>
                    <div class="cPopupMenu2Hidden">
                    </div>
                </div>
                <div class="cPopupMainPanelExpanded cMenuPanelExpend">
                    <div *ngIf="ShowMenu">
                        <div cdkDropListGroup class="row">
                            <div class="col-md-4">
                                <h4 class="cManik-h4">Not In Use Menu List</h4>
                                <div cdkDropList [cdkDropListData]="NotInUseMenuList" class="cTableDragDrop"
                                    (cdkDropListDropped)="drop($event)">
                                    <div class="cTDragDropBox" *ngFor="let row of NotInUseMenuList" cdkDrag
                                        [cdkDragData]="row">
                                        <div class="cTDragDropPlaceHolder" *cdkDragPlaceholder></div>
                                        <div class="row col-lg-12">
                                            <div class="col-lg-10">
                                                {{row.MenuItemText}}
                                            </div>
                                            <div class="col-lg-2" *ngIf="row.AllowReOrder === 'Y'">
                                                <i class="material-icons">open_with</i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <h4 class="cManik-h4">In Use Menu List</h4>
                                <div cdkDropList [cdkDropListData]="InUseMenuList" class="cTableDragDrop"
                                    (cdkDropListDropped)="drop($event)">
                                    <div class="cTDragDropBox" *ngFor="let row of InUseMenuList" cdkDrag
                                        [cdkDragData]="row">
                                        <div class="cTDragDropPlaceHolder" *cdkDragPlaceholder></div>
                                        <div class="row col-lg-12">
                                            <div class="col-lg-10">
                                                {{row.MenuItemText}}
                                            </div>
                                            <div class="col-lg-2">
                                                <div class="cEditMenu" style="cursor: pointer;" (click)="editRow(row);">
                                                    <i class="material-icons">edit</i>
                                                </div>
                                                <div class="cMenuEdit1" style="margin: -8px -35px;"
                                                    *ngIf="row.AllowReOrder === 'Y'">
                                                    <i class="material-icons">open_with</i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <form [formGroup]="MenuForm" #mnuForm="ngForm" *ngIf="IsEdit">
                                    <fieldset>
                                        <legend>
                                            <h4 class="cManik-h4">Update Menu's Property</h4>
                                        </legend>
                                        <div class="col-md-12">
                                            <div class="cDivMenuFormGroup">
                                                <div class="form-group">
                                                    <div class="cDefault"
                                                        [ngClass]="{'cErorr': frmMenu.MenuItemText.invalid && (frmMenu.MenuItemText.touched || mnuForm.submitted),'cSuccess': frmMenu.MenuItemText.valid && frmMenu.MenuItemText.dirty}">
                                                        <h5>Menu Text <span>*</span></h5>
                                                        <input formControlName="MenuItemText" type="text">
                                                        <span *ngIf="mnuForm.submitted && frmMenu.MenuItemText.errors"
                                                            class="cErrorMsg">
                                                            <span *ngIf="frmMenu.MenuItemText.errors.required">
                                                                *required</span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <div class="cDefault">
                                                        <h5>Tag In Menu</h5>
                                                        <mat-checkbox formControlName="TagToMenu"></mat-checkbox>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <div class="cMatdd_main"
                                                        [ngClass]="{'cMatdd_error': frmMenu.SelectedEffectID.invalid && (frmMenu.SelectedEffectID.touched || mnuForm.submitted),'cMatdd_success': frmMenu.SelectedEffectID.valid && frmMenu.SelectedEffectID.dirty}">
                                                        <h5>Effects</h5>
                                                        <mat-select placeholder="Choose Effect"
                                                            formControlName="SelectedEffectID">
                                                            <mat-option *ngFor="let item of DesignerEffects"
                                                                [value]="item.DataValue">{{item.DataText}}</mat-option>
                                                        </mat-select>
                                                        <span
                                                            *ngIf="mnuForm.submitted && frmMenu.SelectedEffectID.errors"
                                                            class="cErrorMsg">
                                                            <span *ngIf="frmMenu.SelectedEffectID.errors.required">
                                                                *required</span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="form-group">
                                                    <div class="cDefault"
                                                        [ngClass]="{'cErorr': frmMenu.DisplayOrder.invalid && (frmMenu.DisplayOrder.touched || mnuForm.submitted),'cSuccess': frmMenu.DisplayOrder.valid && frmMenu.DisplayOrder.dirty}">
                                                        <h5>Display Order <span>*</span></h5>
                                                        <input formControlName="DisplayOrder" type="text">
                                                        <span *ngIf="mnuForm.submitted && frmMenu.DisplayOrder.errors"
                                                            class="cErrorMsg">
                                                            <span *ngIf="frmMenu.DisplayOrder.errors.required">
                                                                *required</span>
                                                        </span>
                                                        <input formControlName="AllowReOrder" type="hidden">
                                                        <input formControlName="MicrositeSectionID" type="hidden">
                                                        <input formControlName="SectionIdentifier" type="hidden">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <br />
                                    <div class="cDivAction">
                                        <button type="submit" *ngIf="!FormSubmitted" (click)="SubmitDataToDatabase();"
                                            class="cTooltipSaveText"></button>
                                        <ManikButtonLoader *ngIf="FormSubmitted"></ManikButtonLoader>
                                    </div>
                                    <div class="clearfix"></div> -->
                                    </fieldset>
                                </form>
                            </div>
                        </div>
                        <div class="cPopupAction">
                            <button class="cButtonPopupSubmit" (click)="SubmitDataToDatabase();"></button>
                        </div>
                    </div>
                    <div class="cPopupWorkSpace cBackgroundMediaSettings" *ngIf="ShowBackground" >
                        <form>
                          <!-- <image-handler [ImageData]="HModel.ImageDataBGMedia"></image-handler> -->
                        </form>
                      </div>
                    <div *ngIf="ShowBackground">
                       
                        <div class="cPopupAction">
                            <button class="cButtonPopupCancel" data-dismiss="modal"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>